export const common = {
  active: 'Active',
  inactive: 'Inactive',
  enabled: 'Enabled',
  disabled: 'Disabled',
  search: 'Search',
  filters: 'Filters',
  export: 'Export',
  import: 'Import',
  refresh: 'Refresh',
  actions: 'Actions',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  create: 'Create',
  view: 'View',
  yes: 'Yes',
  no: 'No',
  confirm: 'Confirm',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  close: 'Close',
  clear: 'Clear',
  today: 'Today',
  yesterday: 'Yesterday',
  lastWeek: 'Last 7 days',
  lastMonth: 'Last 30 days',
  customRange: 'Custom range',
};

export const accessDenied = {
  title: 'Access Denied',
  description: "You don't have permission to access this page. Contact your administrator if you believe this is a mistake.",
  requiredPermission: 'Required permission',
  goBack: 'Go back',
  goHome: 'Go to home',
};

export const validation = {
  required: 'This field is required',
  maxLength: 'Must be at most %{count} characters',
  minLength: 'Must be at least %{count} characters',
  maxValue: 'Must be at most %{max}',
  minValue: 'Must be at least %{min}',
  mustBePositive: 'Must be greater than 0',
  nameInvalidChars: 'Only letters, numbers, spaces, hyphens, and underscores are allowed',
  invalidOption: 'Invalid value',
  invalidUrl: 'Invalid URL',
  invalidUuid: 'Invalid identifier format',
  invalidEmail: 'Invalid email address',
  invalidType: 'Invalid value type',
  formHasErrors: 'Some fields need your attention',
  // Backend business rules
  nameAlreadyExistsInSite: 'Name already exists in this site',
  priorityAlreadyExistsInSite: 'Priority level already exists in this site',
  templateNameAlreadyExists: 'Template name already exists',
  manualCodeAlreadyInUse: 'Manual code already in use',
  manualCodeFormat: 'Manual code must be 4 characters using only: 23456789ACDEFGHJKMNPQRTUVWXY',
  singlePhaseVoltageCap: 'Single phase voltage cannot exceed 480V',
  maxPowerBelowCapacity: 'Cannot reduce max power below %{min} kW (total charger capacity)',
  siteNotFound: 'Site not found',
  loadGroupNotFound: 'Load group not found',
  loadGroupDifferentSite: 'Load group belongs to a different site',
  chargerTypeIdAlreadyExists: 'Charger type ID already exists',
  chargerTypeNameAlreadyExists: 'Charger type name already exists',
  firmwareVersionAlreadyExists: 'Firmware version already exists for this vendor/model',
  fileRequired: 'File is required',
  vendorRequired: 'Vendor is required',
  modelRequired: 'Model is required',
  versionRequired: 'Version is required',
  mustNotBeEmpty: 'Must not be empty',
  vendorCodeAlreadyExists: 'Vendor code already exists',
  bulkVendorRequired: 'Vendor is required for bulk updates',
  bulkModelRequired: 'Model is required for bulk updates',
  targetTypeInvalid: 'Target type must be one of: charger, site, or bulk',
  firmwareNotFound: 'Firmware not found',
  firmwareInactive: 'Cannot use inactive firmware for updates',
  vendorNotFound: 'Vendor not found',
  phoneNumberAlreadyExists: 'Phone number already exists',
  appUserNotFound: 'App user not found',
  rfidUserNotFound: 'RFID user not found',
  cardLinkExclusive: 'Card must be linked to either an app user or an RFID user, but not both',
  usernameInUse: 'Username is already in use',
  emailInUse: 'Email address is already in use',
  roleNameAlreadyExists: 'Role name already exists',
  supabaseConnectionNameAlreadyExists: 'A Supabase connection with this name already exists',
  feeTemplateNameAlreadyExists: 'Fee template name already exists',
  feeTemplateNotFound: 'Fee template not found',
  feeTemplateInactive: 'Cannot use an inactive fee template',
  entityNotFound: '%{type} not found',
  scheduleOverlap: 'Schedule overlaps with an existing schedule for this entity',
  feeStructureRequired: 'Fee structure is required when not using a template',
  currencyRequired: 'Currency is required when not using a template',
  promotionCodeAlreadyExists: 'A promotion with this code already exists',
  sharedCodeRequired: 'Shared code type requires a code',
  codeTypeNoneNoCode: 'Code type "none" should not have a code',
  validUntilAfterValidFrom: 'Valid until must be after valid from',
  titleRequired: 'Title is required',
  displayTypeInvalid: 'Display type must be image or gradient',
  imageUrlRequired: 'Image URL is required for image banners',
  gradientStartColorRequired: 'Gradient start color is required for gradient banners',
  gradientEndColorRequired: 'Gradient end color is required for gradient banners',
  groupNameAlreadyExists: 'A group with this name already exists',
  timezoneInvalid: 'The provided timezone is not valid',
  settingKeyAlreadyExists: 'A setting with this key already exists',
  currentPasswordIncorrect: 'Current password is incorrect',
  verificationCodeInvalid: 'Verification code is invalid or expired',
  passwordIncorrect: 'Password is incorrect',
  passwordRequired: 'Password is required',
};